module.exports = __webpack_public_path__ + "img/hr-grass-2.d593efe2.png";